import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.authService.isAuthenticated()) {
      return true;
    }

    if (this.authService.hasToken()) {
      return this.authService.fetchMe().pipe(
        map((response) => {
          this.authService.refreshUsuario(response.data);
          return true;
        }),
        catchError(() => {
          this.authService.logout();
          return of(this.router.parseUrl('/login'));
        })
      );
    }

    return this.router.parseUrl('/login');
  }
}
